<template>
  <div class="handler-container">
    <div v-if="!isDenied">
      <slot></slot>
    </div>
    <div v-else class="handler-access-denied" :style="topMargin">
      <Message severity="info" :closable="false"
        >У Вас нет доступа к ресурсу. Обратитесь к администратору.</Message
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import Message from "primevue/message";

const topMargin = computed(() => {
  let top = 0;
  if (props.top) {
    top = props.top;
  }
  return `margin-top: ${top}px`;
});

const props = defineProps<{
  isDenied?: boolean;
  top?: number;
}>();
</script>

<style scoped lang="scss">
.handler-container {
  position: relative;
  width: 100%;
  height: 100%;
  max-height: 100%;
}

.handler-access-denied.center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
